export default __webpack_public_path__ + "static/media/icon_bold.bc0d3fcd.svg";